module.exports = __webpack_public_path__ + "img/ENTJ.170e520b.png";